import { createFileRoute } from '@tanstack/react-router'
import EditionComments from 'Edition/components/sections/Comments/EditionComments'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/comments')({
    component: EditionComments,
})
